import React, { useState, useEffect, Suspense, lazy } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
const Custom404 = lazy(() => import("../features/components/custom-404"));
import Loader from "../components/Loader/Loader";
import Layout from "../userAuth/mainLayout";
import PrivateRoute from "../userAuth/protectedRoute";
const ShortURLAnimationViewnew = lazy(() => import("../features/animationView/animationViewnew.tsx"));
const LoopPlayerKiosk = lazy(() => import("../users/animationloop/loopPlayerKiosk.tsx"));
const LOCAL_SHORT_URL = import.meta.env.VITE_LOCAL_SHORT_URL;
import Cookies from "js-cookie";
import useGoogleAnalytics from "../hooks/useGoogleAnalaytics.ts";
import { privateRoutes, publicRoutes } from "../utils/routeConfig.tsx";
import RoutesListener from "../utils/routeChangeListener.tsx";
import CookieConsent from "../utils/cookieConsent.tsx";

function GoogleAnalyticsTracker() {
  useGoogleAnalytics();
  return null;
}

const AppRoutes: React.FC = () => {
  const [adminLoader, setAdminLoading] = useState(true);
  const domain = window.location.hostname;

  useEffect(() => {
    const timer = setTimeout(() => {
      setAdminLoading(false);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  if (adminLoader) {
    return <Loader />;
  }

  const PublicRoute = ({ children }: { children: JSX.Element }) => {
    const token: any = Cookies.get("userToken");
    return token ? <Navigate to="/home" replace /> : children;
  };

  return (
    <BrowserRouter>
      <RoutesListener />
      <GoogleAnalyticsTracker />
      <Suspense fallback={<Loader />}>
        <Routes>
          {/* Private Routes */}

          <>
            {privateRoutes.map((route) => (
              <Route
                key={route.name}
                path={route.path}
                element={
                  <PrivateRoute>
                    <Layout>
                      <route.component />
                    </Layout>
                  </PrivateRoute>
                }
              />
            ))}
          </>

          {/* Public Routes */}

          <>
            {publicRoutes.map((routes) => (
              <Route
                key={routes.path}
                path={routes.path}
                element={
                  <PublicRoute>
                    <routes.component />
                  </PublicRoute>
                }
              />
            ))}
          </>

          {/*
            Kiosk loop-video player: intentionally NOT part of `publicRoutes`/`PublicRoute`,
            since `PublicRoute` redirects to /home whenever a `userToken` cookie is present -
            a kiosk browser profile carrying a stale cookie from prior use must still work.
            This page manages its own kiosk session entirely independently of that cookie.
          */}
          <Route path="/loop-player/:token" element={<LoopPlayerKiosk />} />

          {/* Undefined Routes */}
          <>
            {domain === LOCAL_SHORT_URL ? (
              <>
                <Route path="/:shortCode" element={<ShortURLAnimationViewnew />} />
              </>
            )
              : <Route path="*" element={<Custom404 />} />
            }

            {/* <Route path="/loopvideo" element={<PlayLoop />} /> */}
          </>
        </Routes>
      </Suspense>
      <CookieConsent />
    </BrowserRouter>
  );
};

export default AppRoutes;
